<template>
	<div>
		<h6 class="mt-4 text-body-1 font-weight-bold">作業指示書に関する設定</h6>
		<v-row no-gutters align="end">
			<p class="font-weight-bold text-body-1 mt-4">作業指示書</p>
			<v-checkbox
				class="ml-4"
				dense
				v-model="TODO"
				hide-details
				label="有"
				@change="changeWorkInstruction"
			/>
		</v-row>
		<v-sheet class="mt-4" elevation="0" max-width="600px" width="100%">
			<table width="100%" class="show-dialog-table">
				<tbody>
					<ShowDetailRecord :columnName="'作業指示書名'">
						<template v-slot:value>
							<v-text-field
								v-model="TODO"
								:rules="[rules.required]"
								background-color="white"
								outlined
								dense
								hide-details
							/>
						</template>
					</ShowDetailRecord>
				</tbody>
			</table>
		</v-sheet>
		<v-divider class="mt-4" />
		<h6 class="mt-4 text-body-1 font-weight-bold">作業指示書 大枠設定</h6>
		<v-row no-gutters class="flex-nowrap mt-4">
			<v-sheet elevation="0" min-width="250px" width="250px" class="pr-2">
				<h6 class="font-weight-bold">大枠一覧</h6>
				<div>
						<!--TODO: v-for="(大枠, i) in 全大枠" :key="i'" @click="changeTab(i)" -->
					<div class="process-tab-item mt-4">
						<v-text-field v-model="TODO" outlined dense hide-details />
					</div>
				</div>
				<v-btn class="mt-4" color="secondary" @click="addOutline">
					<v-icon class="mr-1"> mdi-plus </v-icon>
					大枠を追加
				</v-btn>
			</v-sheet>

			<v-sheet elevation="0" class="pl-2" style="flex-grow: 1">
				<v-tabs-items v-model="outlineTab">
					<!--TODO: v-for="(大枠, i) in 全大枠" :key="i'"-->
					<v-tab-item>
						<v-row no-gutters style="width: 100%">
							<v-col sm="6" cols="12" class="pr-sm-1">
								<v-sheet elevation="0" width="100%">
									<table width="100%" class="show-dialog-table">
										<tbody>
											<!-- TODO: <template v-for="(項目, i) in 大枠の項目"> -->
											<ShowDetailRecord :columnName="'項目名'">
												<template v-slot:value>
													<v-text-field
														v-model="TODO"
														:rules="[]"
														background-color="white"
														outlined
														dense
														hide-details
													/>
												</template>
											</ShowDetailRecord>
											<ShowDetailRecord :columnName="'データ形式'">
												<template v-slot:value>
													<v-select
														:items="[]"
														v-model="TODO"
														:rules="[rules.required]"
														background-color="white"
														outlined
														dense
														hide-details
													/>
												</template>
											</ShowDetailRecord>
											<!-- </template> -->
										</tbody>
									</table>
									<v-btn class="mt-4" color="secondary" @click="addOutlineItem">
										<v-icon class="mr-1"> mdi-plus </v-icon>
										項目を追加
									</v-btn>
								</v-sheet>
							</v-col>
						</v-row>
					</v-tab-item>
				</v-tabs-items>
			</v-sheet>
		</v-row>
		<v-divider class="mt-4" />
		<h6 class="mt-4 text-body-1 font-weight-bold">テンプレート基本情報設定</h6>
		<v-sheet class="mt-4" elevation="0" max-width="600px" width="100%">
			<table width="100%" class="show-dialog-table">
				<tbody>
					<ShowDetailRecord :columnName="'シート名'">
						<template v-slot:value>
							<v-text-field
								v-model="check_sheet_template.name"
								:rules="[rules.required]"
								background-color="white"
								outlined
								dense
								hide-details
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'対象分類'">
						<template v-slot:value>
							<v-select
								v-model="check_sheet_template.TODO"
								:rules="[rules.required]"
								:items="[]"
								item-value="id"
								item-text="name"
								background-color="white"
								outlined
								dense
								hide-details
							/>
						</template>
					</ShowDetailRecord>
				</tbody>
			</table>
		</v-sheet>
		<v-divider class="mt-4" />
		<h6 class="mt-4 text-body-1 font-weight-bold">チェック項目設定</h6>
		<v-row no-gutters class="flex-nowrap mt-4">
			<v-sheet elevation="0" min-width="250px" width="250px" class="pr-2">
				<h6 class="font-weight-bold">工程一覧</h6>
				<v-tabs hide-slider class="mt-4" v-model="tab" vertical active-class="active-tab">
					<!--TODO: v-for="(工程, i) in 全工程" :key="i'"-->
					<v-tab height="40px" class="process-tab-item"> XXXX </v-tab>
					<v-tab height="40px" class="process-tab-item"> XXXX </v-tab>
					<v-tab height="40px" class="process-tab-item"> XXXX </v-tab>
				</v-tabs>
				<v-btn class="mt-4" color="secondary" @click="addOutline">
					<v-icon class="mr-1"> mdi-plus </v-icon>
					工程を追加
				</v-btn>
			</v-sheet>
			<v-sheet elevation="0" class="pl-2">
				<v-tabs-items v-model="tab">
					<!--TODO: v-for="(工程, i) in 全工程" :key="i'"-->
					<v-tab-item>
						<v-row no-gutters class="">
							<v-col sm="6" cols="12" class="pr-sm-1">
								<v-sheet elevation="0">
									<table width="100%" class="show-dialog-table">
										<tbody>
											<ShowDetailRecord :columnName="'QC番号'">
												<template v-slot:value>
													<v-text-field
														v-model="TODO"
														:rules="[]"
														background-color="white"
														outlined
														dense
														hide-details
													/>
												</template>
											</ShowDetailRecord>
											<ShowDetailRecord :columnName="'工程名'">
												<template v-slot:value>
													<v-text-field
														v-model="TODO"
														:rules="[rules.required]"
														background-color="white"
														outlined
														dense
														hide-details
													/>
												</template>
											</ShowDetailRecord>
										</tbody>
									</table>
								</v-sheet>
							</v-col>
						</v-row>
						<v-sheet elevation="0" class="my-4 table-container">
							<table width="100%" class="show-dialog-table">
								<tbody>
									<th class="font-weight-bold" :style="width(100)">QC番号</th>
									<th class="font-weight-bold" :style="width(200)">チェック項目</th>
									<th class="font-weight-bold" :style="width(200)">チェック方法</th>
									<th class="font-weight-bold" :style="width(200)">チェック基準</th>
									<th class="font-weight-bold" :style="width(200)">保存結果のデータ形式</th>
								</tbody>
								<tbody>
									<tr v-for="item in [{ id: 1 }]" :key="item.id">
										<td>
											<v-text-field
												v-model="item.qc_number"
												:rules="[rules.required]"
												background-color="white"
												outlined
												dense
												hide-details
											/>
										</td>
										<td>
											<v-text-field
												v-model="item.name"
												:rules="[rules.required]"
												background-color="white"
												outlined
												dense
												hide-details
											/>
										</td>
										<td>
											<v-text-field
												v-model="item.check_method"
												:rules="[rules.required]"
												background-color="white"
												outlined
												dense
												hide-details
											/>
										</td>
										<td>
											<v-text-field
												v-model="item.standard"
												:rules="[rules.required]"
												background-color="white"
												outlined
												dense
												hide-details
											/>
										</td>
										<td>
											<v-select
												v-model="TODO"
												:rules="[]"
												:items="dataTypeOptions"
												item-value="id"
												item-text="name"
												background-color="white"
												outlined
												dense
												hide-details
											/>
										</td>
									</tr>
								</tbody>
							</table>
							<v-btn class="mt-4" color="secondary" @click="addItem">
								<v-icon class="mr-1"> mdi-plus </v-icon>
								項目を追加
							</v-btn>
						</v-sheet>
					</v-tab-item>
				</v-tabs-items>
			</v-sheet>
		</v-row>
	</div>
</template>

<script>
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import IncrementalSearchForm from "../../shared/IncrementalSearchForm.vue"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	components: {
		IncrementalSearchForm,
		ShowDetailRecord,
	},
	props: {
		check_sheet_template: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			rules: rules,
			common: common,
			showInstruction: false,
			tab: 0,
			outlineTab: 0,
			TODO: null,
			dataTypeOptions: [
				// TODO 仮
				"可否",
				"OK NG",
				"有無",
				"日時",
				"日時（期間）",
				"自由記入",
				"目視のみ",
				"材料名記入",
				"LOT No.記入",
				"寸法記入(mm)",
				"数量記入",
			],
		}
	},
	mounted() {},
	methods: {
		// TODO: 作るモデル名によって、以下の関数を変更すること
		changeWorkInstruction() {},
		changeDisplayProcess(i) {},
		addOutline() {},
		addOutlineItem() {},
		addProcess() {},
		addItem() {},
		changeTab(i) {
			this.outlineTab = i
		},
		width(number) {
			return { "min-width": `${number}px`, "max-width": `${number}px` }
		},
	},
	computed: {
		checkSheetTemplate: {
			get() {
				return this.check_sheet_template
			},
			set(newVal) {
				return this.$emit("update:check_sheet_template", newVal)
			},
		},
	},
	watch: {},
}
</script>


<style lang="scss" scoped>
.active-tab {
	background-color: lightgreen;
}
.process-tab-item {
	border-bottom: 1px solid whitesmoke;
}
</style>